var map = {
	"./maps/guest.js": 168,
	"./root.opt": 169
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 167;


//////////////////
// WEBPACK FOOTER
// ./options (\/|\\)(?!_)[\w\.\-\\]+\.(opt|js)$
// module id = 167
// module chunks = 5